import { useCallback, useEffect, useState } from "react";

import { useComposerIsLoading } from "Flocknote/stateHooks";

import {
  useActiveAction,
  useSendTextActiveAction,
} from "Dashboard/components/WhatsNext/whatsNextStore";
import { useSendTextRef } from "NavBar/navBarStore";

import FnrContainedIcon from "UI/FnrContainedIcon";
import { navColors } from "UI/colors";

import useIsHoverFocused from "Utilities/Hooks/useIsHoverFocused";

import Button from "./components/Button";
import { hoverTextKeys, useHoverTextKey } from "./toolbarStore";

const SendText = () => {
  const [wasClicked, setWasClicked] = useState(false);
  const [composerIsLoading, setComposerIsLoading] = useComposerIsLoading();
  const [, setHoverTextKey] = useHoverTextKey();
  const sendTextRef = useSendTextRef();
  const isHoverFocused = useIsHoverFocused(sendTextRef);
  const sendTextActiveAction = useSendTextActiveAction();
  const [, setActiveAction] = useActiveAction();

  useEffect(() => {
    if (isHoverFocused) setHoverTextKey(hoverTextKeys.text);
    else setHoverTextKey(hoverTextKeys.noHover);
  }, [isHoverFocused, setHoverTextKey]);

  useEffect(() => {
    if (!composerIsLoading) setWasClicked(false);
  }, [composerIsLoading]);

  const handleClick = useCallback(() => {
    setComposerIsLoading(true);
    setWasClicked(true);
    if (sendTextActiveAction) setActiveAction(undefined);
  }, [sendTextActiveAction, setActiveAction, setComposerIsLoading]);

  return (
    <div
      className="main_button compose_button compose_button_sms"
      data-type="sms"
      data-cy="textComposeButton"
      data-flashing={sendTextActiveAction || undefined}
      style={{ all: "unset" }}
    >
      <Button
        color={navColors.groups}
        onClick={handleClick}
        ref={sendTextRef}
        isFlashing={sendTextActiveAction}
      >
        <FnrContainedIcon
          color="textLight"
          icon="mobile-screen fas"
          shadow
          isLoading={wasClicked && composerIsLoading}
        />
      </Button>
    </div>
  );
};
export default SendText;
